/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".save-layer div.field{margin-bottom:10px}.save-layer .save-cancel{margin-bottom:15px}"];
export { styles as styles };
